import { PortalModel } from "@apps/mf-overview/src/server/portals/model";
import { PortalSortMethods } from "./utils/sort";

export type PortalState = {
  sortedBy: PortalSortMethods;
  portals: Promise<PortalModel[]> | PortalModel[] | undefined;
};

export const initialPortalState = {
  sortedBy: PortalSortMethods.LEXICOGRAPHIC,
  portals: undefined,
};
